'use strict';

exports.__esModule = true;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _createReactClass = require('create-react-class');

var _createReactClass2 = _interopRequireDefault(_createReactClass);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

exports['default'] = _createReactClass2['default']({

  propTypes: {
    routes: _propTypes2['default'].arrayOf(_propTypes2['default'].object.isRequired).isRequired,
    notFoundRoute: _propTypes2['default'].object.isRequired
  },

  getCurrentRoute: function getCurrentRoute() {
    var _props = this.props;
    var routes = _props.routes;
    var notFoundRoute = _props.notFoundRoute;

    var hash = location.hash.slice(2); // removes #!
    for (var i = 0; i < routes.length; i++) {
      var route = routes[i];
      if (route.hash === hash) {
        return route;
      }
    }
    return notFoundRoute;
  },

  handleHashChange: function handleHashChange() {
    this.forceUpdate(function () {
      window.scrollTo(0, 0);
    });
  },

  componentDidMount: function componentDidMount() {
    window.addEventListener('hashchange', this.handleHashChange);
  },

  componentWillUnmount: function componentWillUnmount() {
    window.removeEventListener('hashchange', this.handleHashChange);
  },

  render: function render() {
    var route = this.getCurrentRoute();

    // don't do that at work
    document.title = route.title;

    // this is even dirtier, we know that `route.content` always a <Layout>
    // element, so we just push additional prop to it. Tight coupling FTW.
    return _react2['default'].cloneElement(route.content, { currentHash: route.hash });
  }

});
module.exports = exports['default'];